/**
 * @author       julian@zumper.com (Julian Napolitan)
 * @copyright    Copyright (c) 2022, Zumper
 */

import * as constants from '../constants'
import type { ActionTypes } from '../types'

// This satisfies makes sure that everything in the whitelist is also used in the reducer
export const allowedList = Object.values(constants) satisfies ReadonlyArray<ActionTypes['type']>

// These 2 lines make sure that every action type that the reducer uses is included in the whitelist
declare const shouldBeEmpty: Exclude<ActionTypes['type'], (typeof allowedList)[number]>
false && (shouldBeEmpty satisfies never)
